import { UserService } from './../base-services/user.service';
import { ColumnType } from './column-type';
import { ColumnAligment } from './column-aligment';
export class ColumnData {

    constructor(private userService: UserService){}

    Name: string;
    Label: string;
    Aligment: ColumnAligment;
    Width: string;
    Type: ColumnType;
    Format: string;
    Visible: boolean;
    CanHide: boolean = true;
    TooltipName: string;
    TooltipName2: string;
    condition: (item: any) => boolean; 
    // MaxLength?: number;

    LoadColumnData(data: any){
        let columnsData: ColumnData[] = [];
        let columnData: ColumnData;
        if(data){
            data.forEach(column => {
                columnData = new ColumnData(this.userService);
                columnData.Name = column.name;
                columnData.Label = column.label;
                //columnData.Type = column.type ? column.type : 'text';
                columnData.Type = this.getType(column.type);
                //columnData.Aligment = column.aligment ? column.aligment : column.type == 'number' ? 'right' : 'left';
                columnData.Aligment = this.getAligment(column.aligment, columnData.Type);
                //columnData.Width = column.width;                
                columnData.Width = this.getWidth(column.width);
                //columnData.Format = column.format;
                columnData.Format = this.getFormat(column.format, columnData.Type);
                //columnData.Visible = column.visible ? column.visible : true;
                columnData.Visible = this.getVisible(column.visible, column.condition);
                //columnData.CanHide = column.canHide;
                columnData.CanHide = this.getCanHide(column.canHide);
                columnData.TooltipName = this.getTooltipName(column.tooltipName);
                columnData.TooltipName2 = this.getTooltipName(column.tooltipName2);
                // columnData.MaxLength = column.maxLength
                columnData.condition = column.condition;
                columnsData.push(columnData);
            })
        }
        return columnsData;
    }

    private getAligment(aligment, type){
        if(aligment)
            return aligment;
        switch(type){
            case ColumnType.Text: return ColumnAligment.Left;
            case ColumnType.Number: return ColumnAligment.Right;
            case ColumnType.Date: return ColumnAligment.Left;
            case ColumnType.DateTime: return ColumnAligment.Left;
        }
    }

    private getType(type){
        if(type)
            return type;
        return ColumnType.Text;
    }

    private getWidth(width){
        if(width)
            return width;
        return 'auto';
    }

    private getFormat(format, type){
        if(format)
            return format;
        switch(type){
            case ColumnType.Text: return '';
            case ColumnType.Number: return this.userService.GetNumberFormat();
            case ColumnType.Date: return this.userService.GetDateFormat();
            case ColumnType.DateTime: return this.userService.GetDateTimeFormat();
            case ColumnType.Boolean: return '';
        }
    }

  private getVisible(visible, condition?: (item: any) => boolean): boolean {
    const baseVisible = visible != null ? visible : true;

    if (condition && typeof condition === 'function') {
      try {
        return baseVisible && condition(null);
      } catch {
        return baseVisible;
      }
    }

    return baseVisible;
  }

    private getCanHide(canHide){
        if(canHide)
            return canHide;
        return false;
    }

    private getTooltipName(tooltip){
        if(tooltip != null)
            return tooltip;
        return '';
    }

}
